import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { isEmpty } from "lodash";
import { Button, Col, Divider, Form, Input, Row, Select, Space } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { useMedicinesStore } from "modules/medicines/store";
import { useProductMappingStore } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";

function AddComboProduct({ modalComboShow, setModalComboShow }) {
  const [form] = Form.useForm();
  const [medicinesToShow, setMedicinesToShow] = useState([]);
  const [comboMedicinesToShow, setComboMedicinesToShow] = useState([]);
  const { setToaster } = useToast();
  const { medicinesData, medicinesLoading, fetchMedicinesData } =
    useMedicinesStore();
  const { fetchProductsData, addComboProductData } = useProductMappingStore();

  useEffect(() => {
    fetchMedicinesData();
  }, []);

  const handleModalClose = () => {
    form.resetFields();
    setModalComboShow(false);
  };

  const onSubmit = async (comboData) => {
    comboData.comboItems?.map((combo, index) => {
      let found = {};
      found = medicinesToShow?.find((med) => med.id === combo.variant_id);
      if (!isEmpty(found)) {
        comboData.comboItems[index] = {
          ...comboData.comboItems[index],
          name: found.display_name,
        };
      }
    });
    addComboProductData(comboData, setToaster, fetchProductsData, handleModalClose);
  };

  useEffect(() => {
    if (isEmpty(medicinesData)) setMedicinesToShow([]);
    else {
      const filteredMedicines = medicinesData?.filter((med) =>
        isEmpty(med?.group)
      );
      const filteredComboMedicines = medicinesData?.filter(
        (med) => med?.group === "combo"
      );
      setComboMedicinesToShow([...filteredComboMedicines]);
      setMedicinesToShow([...filteredMedicines]);
    }
  }, [medicinesData]);

  return (
    <Modal
      show={modalComboShow}
      onHide={() => setModalComboShow(false)}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Product Mapping
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Form
            form={form}
            layout="vertical"
            name="product_mapping"
            onFinish={onSubmit}
          >
            <Form.Item
              label="Product ID"
              name="productId"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Combo Name"
              name="medicineId"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Select showSearch optionFilterProp="children">
                {!isEmpty(comboMedicinesToShow) &&
                  comboMedicinesToShow.map((medicine) => (
                    <Option value={medicine.id} key={medicine.id}>
                      {medicine.display_name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Product Principal ID"
              name="principalId"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <br />

            <Form.List label="shift Time" name="comboItems">
              {(fields, { add, remove }) => (
                <Space direction="vertical">
                  {fields.map((field) => (
                    <Row>
                      <Divider>{`Combo Item ${field.name + 1}`}</Divider>
                      <Space direction="horizontal">
                        <Col>
                          <Form.Item
                            label="Medicine"
                            name={[field.name, "variant_id"]}
                            rules={[
                              {
                                required: true,
                                message: "Please fill this",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              style={{ width: 200 }}
                              optionFilterProp="children"
                            >
                              {!isEmpty(medicinesToShow) &&
                                medicinesToShow.map((medicine) => (
                                  <Option value={medicine.id} key={medicine.id}>
                                    {medicine.display_name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Quantity"
                            name={[field.name, "quantity"]}
                            rules={[
                              {
                                pattern: "^[0-9]+$",
                                message: "Please enter a number",
                              },
                              {
                                required: true,
                                message: "Please fill this",
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col>
                          <MinusCircleOutlined
                            style={{ paddingTop: 12, color: "red" }}
                            onClick={() => remove(field.name)}
                          />
                        </Col>
                      </Space>
                    </Row>
                  ))}

                  <Form.Item>
                    <Row>
                      <Button
                        type="dashed"
                        onClick={() => {
                          add();
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Combo Items
                      </Button>
                    </Row>
                  </Form.Item>
                </Space>
              )}
            </Form.List>

            <Form.Item
              label="Price"
              name="price"
              rules={[
                {
                  pattern: "^[0-9]+$",
                  message: "Please enter a number",
                },
                {
                  required: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item style={{ textAlign: "center" }}>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setModalComboShow(false)}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddComboProduct;
